
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: theme.spacing(3),
    padding: theme.spacing(1, 0),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(0.5),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
}));

export const QuizInlineCardRoot = ({ children, className }) => {
  const classes = useStyles();
  return <Box className={clsx(classes.root, className)}>{children}</Box>;
};
